import React from 'react';

export default function Rocketship() {
	// 14
	let style = {
		st24: {
			fill:"#FC5959"
		},
		st0: {
			fill:"#FFFFFF"
		},
		st2: {
			fill:"#A5C6EF"
		},
		st137: {
			opacity:0.4,
			fill:"#FFFFFF",
			enableBackground:"new"
		},
		st120: {
			fill:"#F2F2F2"
		},
		st87: {
			opacity:0.4,
			fill:"#FFFFFF"
		}
	};
	return (
		<g>
			<path style={style.st24} d="M43,347.4899902c-17.6399994,0-25.0799999,16.4100037-15.8199997,41
				c0.2672596,0.7373047,1.0816154,1.1183472,1.8189163,0.8510742c0.3958416-0.1434631,0.7075977-0.4552307,0.8510838-0.8510742
				c2-5.6300049,8.3000011-13.1199951,16.1399975-13.1199951"/>
			<path style={style.st24} d="M92.2799988,347.4899902c17.6399994,0,25.0800018,16.4100037,15.8199997,41
				c-0.2672577,0.7373047-1.0816193,1.1183472-1.8189163,0.8510742c-0.3958435-0.1434937-0.7075958-0.4552307-0.8510818-0.8510742
				c-2-5.6300049-8.3000031-13.1199951-16.1399994-13.1199951"/>
			<path style={style.st0} d="M86.3300018,386.3999939c22.75-58.7099915-14.8000031-88.4299927-18.6699982-89.7399902
				C63.7999992,298,26.25,327.7000122,49,386.3999939l0,0C61.1180496,390.4237366,74.2119522,390.4237366,86.3300018,386.3999939
				L86.3300018,386.3999939z"/>
			<path style={style.st24} d="M86.0599976,317.4899902c-7-13.2900085-16.5500031-20.2200012-18.4000015-20.8200073
				c-1.8499985,0.6099854-11.4199982,7.5299988-18.4000015,20.8200073
				C61.2341728,321.2783203,74.0858231,321.2783203,86.0599976,317.4899902z"/>
			<circle style={style.st2} cx="67.6699982" cy="336.9400024" r="9.8299942"/>
			<path style={style.st137} d="M63.6599998,336.9400024c-1.1763611-0.0032959-2.1273308-0.9595642-2.1240463-2.1359253
				c0.0009575-0.3428955,0.0846786-0.680481,0.2440453-0.9840698c1.7286415-3.2529602,5.7670288-4.4886475,9.0199814-2.7600098
				c1.1746368,0.6242065,2.1358109,1.5853882,2.7600174,2.7600098c0.5467606,1.0415649,0.1456375,2.3291931-0.8959427,2.875946
				c-0.3035965,0.1593628-0.6411743,0.243103-0.9840546,0.2440491h-8H63.6599998z"/>
			<path style={style.st120} d="M45.3199997,375.3699951c1,3.5599976,2.2099991,7.2399902,3.6800003,11l0,0
				c12.1180496,4.0237427,25.2119522,4.0237427,37.3300018,0l0,0c1.4700012-3.7999878,2.6900024-7.480011,3.6800003-11
				c-7.3248901,2.070282-14.9085846,3.0805359-22.5199966,3C54.1699982,378.3699951,45.3199997,375.3699951,45.3199997,375.3699951z"
				/>
			<path style={style.st24} d="M72,359l-3,36c-0.0958176,0.8284302-0.8450623,1.4223328-1.6734924,1.3265076
				C66.6299896,396.2459412,66.0805588,395.6965332,66,395l-3-36c-0.0973434-2.4944153,1.8458786-4.595459,4.3403091-4.6928101
				C69.6804199,354.2158508,71.7027359,355.927063,72,358.25C72.0192795,358.4996338,72.0192795,358.7503662,72,359z"/>
			<path style={style.st24} d="M43.0493889,347.4873962c-17.64258,0-25.0793438,16.4143066-15.8189526,41.0304871
				c0.4644699,1.2346802,2.2206478,1.1945496,2.6657066-0.0472412c2.0177746-5.6299744,8.3022366-13.1209717,16.1350689-13.1209717"/>
			<path style={style.st24} d="M92.2839355,347.4873962c17.6425781,0,25.0793457,16.4143066,15.8189545,41.0304871
				c-0.4644699,1.2346802-2.2206497,1.1945496-2.6657104-0.0472412c-2.0177689-5.6299744-8.3022385-13.1209717-16.1350708-13.1209717"
				/>
			<path style={style.st0} d="M86.3332748,386.4048157c22.75-58.7080078-14.7984161-88.4311218-18.6666641-89.7380981
				c-3.8681641,1.3069763-41.4165802,31.0300903-18.6665802,89.7380981h0.0000191
				c12.1385765,4.0245056,25.1946297,4.0245056,37.3332024,0H86.3332748z"/>
			<path style={style.st24} d="M86.0639648,317.4892578c-6.9785156-13.2922363-16.5456543-20.2160645-18.3974609-20.8225098
				c-1.8515625,0.6064453-11.4187012,7.5305176-18.3972168,20.8225098
				C61.2424316,321.2768555,74.0908203,321.2768555,86.0639648,317.4892578z"/>
			<circle style={style.st2} cx="67.6666641" cy="336.9379578" r="9.8333378"/>
			<path style={style.st87} d="M63.6602135,336.9379578c-1.6021118,0-2.6362877-1.709198-1.8844757-3.1239624
				c1.1199722-2.1075745,3.3378487-3.5426941,5.8909264-3.5426941c2.5530701,0,4.7709503,1.4351196,5.8909225,3.5426941
				c0.7518082,1.4147644-0.2823639,3.1239624-1.8844757,3.1239624H63.6602135z"/>
			<path style={style.st120} d="M45.3151207,375.3701172c0.9927177,3.5569153,2.2125282,7.2351074,3.6849098,11.0346985h0.0000191
				c12.1385765,4.0245056,25.1946297,4.0245056,37.3332024,0h0.0000229c1.47229-3.7993774,2.6920471-7.4773254,3.6847305-11.0340576
				c0,0-9.1953278,2.9996643-22.5233307,2.9996643S45.3151207,375.3701172,45.3151207,375.3701172z"/>
			<path style={style.st24} d="M72,359l-3,36c-0.0690918,0.8284302-0.7966309,1.4440308-1.625,1.375
				c-0.7436523-0.0619507-1.3156738-0.6550903-1.375-1.375l-3-36c-0.2070312-2.4852905,1.6396484-4.6679077,4.125-4.875
				s4.6679688,1.6397095,4.875,4.125C72.0205078,358.4950562,72.0180664,358.7623901,72,359z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Rocketship.js